import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/layout.css';

const Layout = ({ children, isPublic = false }) => {
  return (
    <div className="layout">
      <Header isPublic={isPublic} />
      <div className="content">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;